import React from 'react';

import { IntrinsicPropsWithoutRef } from '../../common/types';
import { LogoBaseComplex, LogoBaseSimple } from '../../logo';

export enum LogoVariant {
  simple = 'simple',
  complex = 'complex'
}

export interface LogoProps extends IntrinsicPropsWithoutRef<'svg'> {
  variant?: LogoVariant;
}

export type LogoType = React.ForwardRefExoticComponent<
  LogoProps & React.RefAttributes<SVGSVGElement>
> & {
  Variant: typeof LogoVariant;
};

const LogoForwardedRef: any = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ variant = LogoVariant.simple, ...props }, ref) => {
    const Logo =
      variant === LogoVariant.complex ? LogoBaseComplex : LogoBaseSimple;
    return <Logo ref={ref} {...props} />;
  }
);

LogoForwardedRef.Variant = LogoVariant;

/**
 * @deprecated Данный логотип более не актуален
 */
export const Logo = LogoForwardedRef as LogoType;
